import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, Paper, PaperProps } from '@material-ui/core'
import { Card, CardActionArea, CardActions, CardContent, CircularProgress, Grid, TextField, List, ListItem, ListItemText } from '@material-ui/core'
import Draggable from 'react-draggable';
import { Autocomplete } from '@material-ui/lab'
import Alert from '@material-ui/lab/Alert/Alert';
import { InsertarBeneficioComplementarioLogic, QuitarBeneficioComplementarioLogic, ObtieneCtaCtecomplementarioLogic } from '../../view-model/Arancel/Arancel.logic';
import IViewBeneficioComplementario from '../../view-interfaces/IViewBeneficioComplementario';
import IViewCombo from '../../view-interfaces/IViewCombo'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import toUpperCamelCase from '../../view-model/Funciones/toUpperCamelCase'
import { ObtieneBancosLogic, ObtieneCuentasLogic } from '../../view-model/Parametros/Parametros.logic';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Separator } from 'office-ui-fabric-react';
const { validarRUT } = require('validar-rut')
const { formatterRut, cleanRut } = require('chilean-formatter')
type Props = {
    idBeneficioC: number;
    estado: boolean;
    callback: any;
    nameBeneficio: string;
    beneficiosC: IViewBeneficioComplementario[];
    idClienteC: number;
}

function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const BeneficioComplementario: React.FC<Props> = ({ estado, callback, beneficiosC, idBeneficioC, nameBeneficio, idClienteC }) => {
    const history = useHistory();
    const location = useLocation();
    const [result, setResult] = useState(false)
    const [guardado, setGuardado] = useState(nameBeneficio !== '' ? true : false)
    const [quitado, setQuitado] = useState(false)
    const [beneficio, setBeneficio] = useState('')
    const [beneficioFinal, setBeneficiofinal] = useState('')
    const [editar, setEditar] = useState(false);
    const beneficiosC2: Array<IViewBeneficioComplementario> = [
        {
            idComplementario: 78,
            idBeneficio: 454,
            nombreBeneficio: 'BECA 100% PUNTAJE PONDERADO',
            nombreComplementario: 'FONDO INTERCAMBIO ACADÉMICO EN EL EXTRANJERO',
            descripcionComplementario: 'Consiste en un semestre de intercambio en una Universidad en el extranjero que mantenga un convenio vigente con la UDD y carrera respectiva. La UDD concurrirá con el financiamiento asociado al intercambio por un monto de U$7.000 para EE.UU, Canadá, Australia, Europa y Asia y con un monto de U$ 5.000 para LAtinoamérica. El alumno podrá ejecutar su intercambio previa autorización de su carrera.',
            fechaInicioComplementario: '2021-01-01T00:00:00',
            fechaTerminoComplementario: '',
            estadoComplementario: true
        },
        {
            idComplementario: 79,
            idBeneficio: 454,
            nombreBeneficio: 'BECA 100% PUNTAJE PONDERADO',
            nombreComplementario: 'AYUDA ECONÓMICA',
            descripcionComplementario: 'Consiste en la entrega de 4 UF mensuales desde marzo a diciembre (incluidos), sólo por el número de años definido en el currículo de la carrera a excepción de los programas de Bachillerato y de Ing. Civil Plan Común. Dicho monto tendrá por finalidad el financiamiento de traslado, alimentación y otros gastos de manutención del alumno.',
            fechaInicioComplementario: '2021-01-01T00:00:00',
            fechaTerminoComplementario: 'null',
            estadoComplementario: true
        },
        {
            idComplementario: 80,
            idBeneficio: 454,
            nombreBeneficio: 'BECA 100% PUNTAJE PONDERADO',
            nombreComplementario: 'PROGRAMA ACADÉMICO DE FORMACIÓN GLOBAL',
            descripcionComplementario: 'El alumno podrá elegir entre uno de los programas académicos de Formación Global que ofrece la carrera: a) Transformación Digital: Digital Bootcamp + Diplomado Transformación Digital. b) Innovación Social: Academia de Innovación Social + Pasantía Internacional ImpactoGlobal UDD. c) Innovación Tecnológica: Makercampus + Pasantía Internacional XTEC. d) Mentalidad Global: Curso Intensivo de Inglés + Pasantía Internacional.',
            fechaInicioComplementario: '2021-01-01T00:00:00',
            fechaTerminoComplementario: 'null',
            estadoComplementario: true
        }
    ];
    const [preCargado, setPreCargado] = useState(true)
    const [openModal, setOpenModal] = useState(false)
    const [openModalCtaCte, setOpenModalCtaCte] = useState(false)
    const [descripcion, setDescripcion] = useState('')

    const listaBancos: Array<IViewCombo> = [];
    const [bancos, setBancos] = useState(listaBancos);

    const _banco: IViewCombo = { ID: 0, descripcion: '' };
    const [valBanco, setValBanco] = useState(_banco)
    const [idBanco, setIdBanco] = useState(0)

    const listaCuentas: Array<IViewCombo> = [];
    const [cuentas, setCuentas] = useState(listaCuentas);

    const _cuenta: IViewCombo = { ID: 0, descripcion: '' };
    const [valCuenta, setValCuenta] = useState(_cuenta)
    const [idCuenta, setIdCuenta] = useState(0)

    const [numCuenta, setNumCuenta] = useState(0)
    const [nombreTitular, setNombreTitular] = useState("")
    const [rutTitular, setRutTitular] = useState("")
    const [estiloRut, setEstiloRut] = useState('form-control js-rut js-will-validate');

    const [idBeneficioAyuda, setIdBeneficioAyuda] = useState(0)
    const [tieneCta, setTieneCta] = useState(true)

    const [nombre, setNombre] = useState("No tengo cta cte, generar un vale vista.")
    const [noTieneCta, setNoTieneCta] = useState(false)

    useEffect(() => {
        if (nameBeneficio !== '') {
            setGuardado(true)
            setResult(true)
            setBeneficio(nameBeneficio)
            setBeneficiofinal(nameBeneficio)
        }
        ObtieneBancosLogic(selListaBancos);
        ObtieneCuentasLogic(selListaCuentas);
    }, [nameBeneficio])
    useEffect(() => {
        /* console.log(idClienteC) */
        if (idClienteC !== 0) {
            ObtieneCtaCtecomplementarioLogic(selListaCtaCte, idClienteC)
        }
    }, [idClienteC])
    const selListaCtaCte = (error: Boolean, err: string, result: any) => {
        try {
            if (error === false) {
                /* console.log(result) */
                setTieneCta(result.numCuenta.toString().length > 0)
                setNumCuenta(result.numCuenta)
                bancos.map((e: any) => {
                    if (e.ID === result.idBanco) {
                        setValBanco({ ID: e.ID, descripcion: e.descripcion })
                        setIdBanco(e.ID)
                    }
                })
                cuentas.map((e: any) => {
                    if (e.ID === result.idTipoCuenta) {
                        setValCuenta({ ID: e.ID, descripcion: e.descripcion })
                        setIdCuenta(e.ID)
                    }
                })
            }
            else {
            }
        } catch (error) {
        }
    }
    const InsertarBeneficioComplementario = (idBeneficio: number, descripcion: string) => {
        setPreCargado(false)
        setQuitado(false)
        setGuardado(false)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */
        /* console.log(descripcion) */
        setBeneficio(descripcion)
        setBeneficiofinal(descripcion)
        
        var data: any = {};
        if (descripcion === "AYUDA ECONÓMICA") {
            setOpenModalCtaCte(true)
            setIdBeneficioAyuda(idBeneficio)
        } else {
            InsertarBeneficioComplementarioLogic(selListaInsertarBeneficios, _params.rut, idBeneficio, _params.codCarrera, _params.periodo, _params.año, 'MATWEB', idBeneficioC, data);
        }
    }
    const QuitarBeneficioComplementario = (idBeneficio: number, descripcion: string) => {
        setPreCargado(false)
        setQuitado(false)
        setGuardado(false)
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */
        /* console.log(idBeneficio) */
        setBeneficio(descripcion)
        setBeneficiofinal('')
        QuitarBeneficioComplementarioLogic(selListaQuitarBeneficios, _params.rut, idBeneficio, _params.codCarrera, _params.periodo, _params.año, 'MATWEB', idBeneficioC)
    }
    const selListaInsertarBeneficios = (error: Boolean, err: string, result: any) => {
        if (error === false) {
            /* console.log(result) */
            setResult(result)
            setGuardado(true)
            setQuitado(false)
            setOpenModalCtaCte(false)
            setIdBanco(0)
            setIdCuenta(0)
            setNumCuenta(0)
            setNombreTitular("")
            setRutTitular("")
            setValCuenta(_cuenta)
            setValBanco(_banco)
        }
        setGuardado(false)
        setQuitado(false)
        setResult(false)
        callback(false, beneficioFinal)
    }
    const selListaQuitarBeneficios = (error: Boolean, err: string, result: any) => {
        if (error === false) {
            /* console.log(result) */
            setResult(result)
            setQuitado(true)
            setGuardado(false)
            setBeneficiofinal('')
        }
        setGuardado(false)
        setQuitado(false)
        setResult(false)
        callback(false, beneficioFinal)
    }
    const selListaBancos = (error: Boolean, err: string, result: IViewCombo[]) => {
        try {
            if (error === false) {
                /* console.log(result) */
                setBancos(result)
            }
            else {
            }
        } catch (error) {
        }
    }
    const selListaCuentas = (error: Boolean, err: string, result: IViewCombo[]) => {
        try {
            if (error === false) {
                /* console.log(result) */
                setCuentas(result)
            }
            else {
            }
        } catch (error) {
        }
    }
    const handleSelectBanco = (event: any, newValue: any) => {
        if (newValue !== null) {
            setIdBanco(newValue.ID);
            setValBanco(newValue);
            //setEditar(true)
        }
    }
    const handleSelectCuenta = (event: any, newValue: any) => {
        if (newValue !== null) {
            setIdCuenta(newValue.ID);
            setValCuenta(newValue);
            //setEditar(true)
        }
    }
    useEffect(() => {
        console.log(rutTitular, rutTitular.length, nombreTitular)
        if (noTieneCta) {
            setEditar(true)
        } else if (idBanco !== 0 && idCuenta !== 0 && numCuenta !== 0 && nombreTitular != "" && rutTitular.length > 10) {
            setEditar(true)
        } else {
            setEditar(false)
        }
    }, [idBanco, idCuenta, numCuenta, noTieneCta, nombreTitular, rutTitular])
    const InsertarCtaCte = () => {
        /*  console.log(idBanco)
         console.log(idCuenta)
         console.log(numCuenta) */
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        var data: any = {
            banco: idBanco,
            tipoCuenta: idCuenta,
            numCuenta: numCuenta,
            nombreTitular: nombreTitular,
            rutTitular: rutTitular
        }
        InsertarBeneficioComplementarioLogic(selListaInsertarBeneficios, _params.rut, idBeneficioAyuda, _params.codCarrera, _params.periodo, _params.año, 'MATWEB', idBeneficioC, data);
    }
    return (
        <>
            <Dialog open={estado}
                fullWidth={true}
                aria-labelledby="draggable-dialog-title">

                {beneficiosC.map((e: IViewBeneficioComplementario) => {
                    return (
                        <div>
                            <div style={{ display: 'flex' }}>
                                <Grid container item xs={6} sm={6} xl={6} direction="column" alignItems="stretch">
                                    <Card elevation={0}>
                                        <div>
                                            <CardContent>
                                                <Grid container direction="row" alignItems="stretch"  >
                                                    <Grid item xs={12}>
                                                        <List dense >
                                                            <ListItem >
                                                                <div style={{ display: 'contents' }}>
                                                                    {/* <label style={{fontSize:12}}>Descripción: </label>&nbsp;&nbsp; */}
                                                                    <ListItemText style={{ marginTop: 2 }} primary='Nombre:' secondary={e.nombreComplementario} />
                                                                </div>
                                                            </ListItem>
                                                            <ListItem >
                                                                <div style={{ display: 'contents' }}>
                                                                    {/* <label style={{fontSize:12}}>Descripción: </label>&nbsp;&nbsp; */}
                                                                    <a style={{ textDecoration: 'underline', color: '#0062a1', cursor: 'pointer' }} onClick={() => {
                                                                        setDescripcion(e.descripcionComplementario)
                                                                        setOpenModal(true)
                                                                    }}>Ver Detalle</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                    {
                                                                        e.nombreComplementario === "AYUDA ECONÓMICA" && tieneCta ?
                                                                            <a style={{ textDecoration: 'underline', color: '#0062a1', cursor: 'pointer' }} onClick={() => {
                                                                                setOpenModalCtaCte(true)
                                                                            }}>Ver Cta Cte</a>
                                                                            :
                                                                            ""
                                                                    }
                                                                </div>
                                                            </ListItem>


                                                        </List>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </div>
                                    </Card>
                                </Grid>
                                <Grid container item xs={6} sm={6} xl={6} direction="column" alignItems="stretch">
                                    <Card elevation={0}>
                                        <div>
                                            <CardContent>
                                                <Grid container direction="row" alignItems="stretch"  >
                                                    <Grid item xs={12}>
                                                        <List dense >
                                                            <ListItem >
                                                                <div style={{ display: 'contents' }}>
                                                                    <div style={{ float: 'right', display: 'contents' }}>
                                                                        <Button style={(nameBeneficio === e.nombreComplementario) ? { border: '1px solid #0062a1', color: 'white', backgroundColor: '#0062a1' } : { border: '1px solid gray' }} /* disabled={(beneficio === e.descripcionComplementario && guardado) ? true : false} */ autoFocus onClick={() => {
                                                                            InsertarBeneficioComplementario(e.idComplementario, e.nombreComplementario)
                                                                        }} color="inherit">Seleccionar</Button> &nbsp;&nbsp;&nbsp;
                                                                        <Button style={{ border: '1px solid gray' }} disabled={(nameBeneficio === e.nombreComplementario) ? false : true} autoFocus onClick={() => {
                                                                            QuitarBeneficioComplementario(e.idComplementario, e.nombreComplementario)
                                                                        }} color="inherit">Quitar</Button>
                                                                        &nbsp;&nbsp;
                                                                        {/* <div><img style={{ cursor: 'pointer' }} width={20} height={20} src={question} onClick={() => {
                                                                            setDescripcion(e.descripcionComplementario)
                                                                            setOpenModal(true)
                                                                        }} ></img></div> */}
                                                                    </div>
                                                                </div>
                                                            </ListItem>
                                                        </List>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </div>
                                    </Card>
                                </Grid>

                            </div>
                            {/* <Grid container item xs={12} sm={12} xl={12} direction="column" alignItems="stretch">
                                <Card elevation={0}>
                                    <div>
                                        <CardContent>
                                            <Grid container direction="row" alignItems="stretch"  >
                                                <Grid item xs={12}>
                                                    <List dense >
                                                        <ListItem >
                                                            <div style={{ display: 'contents' }}>
                                                                <ListItemText style={{ marginTop: -30 }} primary='Descripción:' secondary={e.descripcionComplementario} />
                                                            </div>
                                                        </ListItem>
                                                    </List>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </div>
                                </Card>
                            </Grid> */}
                        </div>
                    )
                })}
                <DialogActions>
                    {
                        idBeneficioC === 457 ?
                            <div style={{ marginBottom: '2rem', color: 'gray', fontSize: 12 }}>
                                <div className="enrollment__subtitle">El área de Matrículas se comunicará contigo a la brevedad para confirmar si mantienen el beneficio en la Matrícula o bien optas por el fondo intercambio extranjero.</div>
                            </div>
                            : ""
                    }
                </DialogActions>
                <DialogActions>
                    {
                        !preCargado ?
                            guardado ?
                                result ?
                                    <Alert variant="outlined"
                                        /* icon={<CheckIcon fontSize="inherit" />} */
                                        iconMapping={{
                                            info: <CheckCircleOutline fontSize="inherit" />,
                                        }}
                                        severity="info">Beneficio Complementario '{beneficio}' guardado exitosamente.</Alert> :
                                    <Alert variant="outlined" severity="warning">Ocurrió un problema al guardar el beneficio '{beneficio}'</Alert>
                                : ""
                            : ""
                    }
                    {
                        !preCargado ?
                            quitado ?
                                result ?
                                    <Alert variant="outlined"
                                        /* icon={<CheckIcon fontSize="inherit" />} */
                                        iconMapping={{
                                            info: <CheckCircleOutline fontSize="inherit" />,
                                        }}
                                        severity="info">Beneficio Complementario '{beneficio}' eliminado exitosamente.</Alert> :
                                    <Alert variant="outlined" severity="warning">Ocurrió un problema al eliminar el beneficio '{beneficio}'</Alert>
                                : ""
                            : ""
                    }


                    <Button autoFocus onClick={() => {
                        setGuardado(false)
                        setQuitado(false)
                        setResult(false)
                        callback(false, beneficioFinal)
                    }} color="primary">Salir</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="draggable-dialog-title"
                maxWidth={'xs'}>
                <DialogContent>
                    <div style={{ textAlign: 'left' }}>
                        <Grid container spacing={0} item xs={12}>
                            <Grid container item xs={12} sm={12} xl={12} direction="column" alignItems="stretch">
                                <Card elevation={0}>
                                    <div>
                                        <CardContent>
                                            <Grid container direction="row" alignItems="stretch"  >
                                                <Grid item xs={12}>
                                                    <List dense >
                                                        <ListItem >
                                                            <div style={{ display: 'contents' }}>
                                                                {/* <label style={{fontSize:12}}>Descripción: </label>&nbsp;&nbsp; */}
                                                                <ListItemText primary='Descripción:' secondary={descripcion} />
                                                            </div>
                                                        </ListItem>
                                                    </List>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </div>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => {
                        setOpenModal(false)
                    }} color="primary" >Cerrar</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openModalCtaCte}
                onClose={() => setOpenModalCtaCte(false)}
                aria-labelledby="draggable-dialog-title"
                maxWidth={'xs'}>
                <DialogContent>
                    <div style={{ textAlign: 'left' }}>
                        <Grid container spacing={0} item xs={12}>
                            <Grid container item xs={12} sm={12} xl={12} direction="column" alignItems="stretch">
                                <Card elevation={0}>
                                    <div>
                                        <CardContent>
                                            <Grid container direction="row" alignItems="stretch"  >
                                                <h3>Datos de transferencia del alumno</h3>
                                                <br></br>
                                                <br></br>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl component="fieldset" variant="standard">
                                                        {/* <FormLabel component="legend">------</FormLabel> */}
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={noTieneCta}
                                                                        onChange={(e, i) => setNoTieneCta(i)}
                                                                        name={nombre} />
                                                                }
                                                                label={nombre}
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </Box>
                                                <br></br>
                                                {
                                                    noTieneCta ?
                                                        ""
                                                        :
                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <div className="form-group">
                                                                <label htmlFor="firstnameinsured">Nombre Titular <span className="required">*</span></label>
                                                                <input id="firstnameinsured"
                                                                    name="firstname"
                                                                    className="form-control js-will-validate"
                                                                    type="text"
                                                                    onChange={(e: any) => {
                                                                        setNombreTitular(e.target.value)
                                                                    }}
                                                                    value={nombreTitular}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="firstnameinsured">Rut Titular <span className="required">*</span></label>
                                                                <input
                                                                    className={estiloRut}
                                                                    type="text"
                                                                    value={rutTitular}
                                                                    maxLength={13}
                                                                    placeholder={'99.999.999-9'}
                                                                    onChange={(e) =>
                                                                        setRutTitular(formatterRut(e.target.value.trim()))
                                                                    } />
                                                            </div>
                                                            <div className="form-group form-group--genero">
                                                                <p>Banco <span className="required">*</span></p>
                                                                <Autocomplete
                                                                    style={{ marginTop: -25, marginBottom: -10 }}
                                                                    id="listaBancos"
                                                                    value={valBanco}
                                                                    options={bancos}
                                                                    noOptionsText={'No existe la opción.'}
                                                                    size='small'
                                                                    getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                                                                    onChange={handleSelectBanco}
                                                                    renderInput={params => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant='outlined'
                                                                            placeholder="Seleccione Banco"
                                                                            margin="normal"
                                                                            fullWidth
                                                                            inputProps={{
                                                                                ...params.inputProps,
                                                                                autoComplete: 'new-password',
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            <div className="form-group form-group--genero">
                                                                <p>Tipo Cuenta <span className="required">*</span></p>
                                                                <Autocomplete
                                                                    style={{ marginTop: -25, marginBottom: -10 }}
                                                                    id="listaBancos"
                                                                    value={valCuenta}
                                                                    options={cuentas}
                                                                    noOptionsText={'No existe la opción.'}
                                                                    size='small'
                                                                    getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                                                                    onChange={handleSelectCuenta}
                                                                    renderInput={params => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant='outlined'
                                                                            placeholder="Seleccione Banco"
                                                                            margin="normal"
                                                                            fullWidth
                                                                            inputProps={{
                                                                                ...params.inputProps,
                                                                                autoComplete: 'new-password',
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="firstnameinsured">N° Cuenta <span className="required">*</span></label>
                                                                <input id="firstnameinsured"
                                                                    name="firstname"
                                                                    className="form-control js-will-validate"
                                                                    type="number"
                                                                    onChange={(e: any) => {
                                                                        if (e.target.value.length < 20) {
                                                                            setNumCuenta(e.target.value)
                                                                            //setEditar(true)
                                                                        }

                                                                    }}
                                                                    value={numCuenta}
                                                                />
                                                            </div>
                                                        </Grid>
                                                }

                                                <br></br>
                                                <br></br>

                                            </Grid>
                                        </CardContent>
                                    </div>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => {
                        InsertarCtaCte()
                    }} disabled={!editar} color="primary" >Guardar</Button>
                    <Button autoFocus onClick={() => {
                        setOpenModalCtaCte(false)
                    }} color="primary" >Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default BeneficioComplementario;